<template>
  <div class="candidate-experiences-list">
    <div :class="xp.is_verified ? `candidate-experiences-list-qualification-verfied` : `candidate-experiences-list-qualification`">
      {{ xp.qualification }}
      <ExtraCertificationBadge
        v-if="xp.is_verified"
        :label="$t('ETAB.PAGES.EXTRA.@VERIFIED')"
        :top="2"
        :right="-10"
        color="#ff2c55"
        class="extra-certification-badge"
      >
        <template #picture>
          <img :src="extracadabraPicture" alt="verified" class="picture" />
        </template>
      </ExtraCertificationBadge>
    </div>

    <div v-for="(experience, index) in displayedExperience" :key="index" class="candidate-experiences-list-item flex row q-mt-md">
      <div v-if="experience.etab_experiences.length > 1" class="candidate-experiences-list-container">
        <div class="candidate-experiences-list-item-timeline">
          <div class="candidate-experiences-list-item-dot" />
          <div class="candidate-experiences-list-item-line" :class="{ 'experience-line-adjusted': props.xp.experiences.length >= 2 }" />
        </div>
        <MultipleExperiencesComponent :experience="experience" />
      </div>
      <div v-else class="candidate-experiences-list-container">
        <div class="candidate-experiences-list-item-timeline">
          <div class="candidate-experiences-list-item-dot" />
          <div class="candidate-experiences-list-item-line" :class="{ 'experience-line-adjusted': props.xp.experiences.length >= 2 }" />
        </div>
        <SingleExperienceComponent :shift="experience.etab_experiences[0]" />
      </div>
    </div>
    <div v-if="xp.experiences.length > 2" class="text-center">
      <QBtn
        class="text-underline"
        flat
        dense
        no-caps
        :label="showMore ? $t('ETAB.PAGES.EXTRA.@SHOW_LESS_EXPERIENCES') : $t('ETAB.PAGES.EXTRA.@SHOW_MORE_EXPERIENCES')"
        @click="toggleShowMore"
      />
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, defineProps } from "vue";
  import SingleExperienceComponent from "./SingleExperience.component.vue";
  import MultipleExperiencesComponent from "./MultipleExperiences.component.vue";
  import ExtraCertificationBadge from "@core/components/design-system/ExtraCertificationBadge.component.vue";

  const props = defineProps({
    xp: {
      type: Object,
      default: () => ({}),
    },
  });
  const showMore = ref(false);
  const displayedExperience = computed(() => {
    return showMore.value ? props.xp.experiences : props.xp.experiences.slice(0, 2);
  });
  const toggleShowMore = () => {
    showMore.value = !showMore.value;
  };
  const logo = require("@etab/assets/img/extra_logo_white.png");
  const extracadabraPicture = ref(logo);
</script>

<style lang="scss">
  .candidate-experiences-list {
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    margin-bottom: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    &-qualification {
      font-size: 20px;
      font-weight: 500;
      padding-top: 10px;
      padding-left: 16px;
    }
    &-qualification-verfied {
      position: relative;
      font-size: 20px;
      font-weight: 500;
      padding-top: 3px;
      padding-bottom: 3px;
      padding-left: 16px;
      background-color: #ffeaee;
    }
    .extra-certification-badge {
      .picture {
        width: 20px;
        height: 20px;
      }
    }
    &-item {
      display: flex;
      position: relative;
      &-timeline {
        position: relative;
        margin-right: 10px;
        margin-left: 10px;
        width: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      &-dot {
        width: 16px;
        height: 16px;
        background-color: #ccc;
        border-radius: 50%;
        z-index: 1;
      }

      &-line {
        position: absolute;
        top: 20px;
        width: 3px;
        height: calc(100% - 40px);
        background-color: #ccc;

        &.experience-line-adjusted {
          height: calc(100% - 20px);
        }
      }
    }
    &-container {
      width: 100%;
      padding-left: 10px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      padding-right: 5px;
    }
  }
</style>
